import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import "modules/KioskDashboard/components/CreateUpdateKioskModal/components/KioskPrivateKeyModal/KioskPrivateKeyModal.scss";
import { handleCopyToClipboard } from "modules/ManufacturerDashboard/utils";

type KioskPrivateKeyModalProps = {
  privateKey: string;
  onClose: () => void;
};

export const KioskPrivateKeyModal = ({ privateKey, onClose }: KioskPrivateKeyModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={Boolean(privateKey)} className="KioskPrivateKeyModal">
      <Modal.Header>
        <div className="header-button-container">
          {t("v8_private_key", "Private key")}
          <Button className="modal-close-btn" basic onClick={onClose}>
            <Icon className="xmark" />
          </Button>
        </div>
      </Modal.Header>
      <Modal.Content>
        <p>{t("v8_key_displayed_once_ensure_copy", "This key will be displayed only once, make sure to copy it and proceed to setup.")}</p>
        <div className="kiosk-private-key-modal-content" onClick={() => handleCopyToClipboard(privateKey, t("v8_private_key_copied", "Private key copied to clipboard"))}>
          <Icon name="copy outline" />
          <div>{privateKey}</div>
        </div>
      </Modal.Content>
    </Modal>
  );
};
